/* eslint-disable no-useless-return */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, {
  useEffect,
  useRef,
  InputHTMLAttributes,
  useCallback,
  useState,
} from 'react';
import { useField } from '@unform/core';

import inputDateIcon from 'assets/svg/inputDateIcon.svg';
import Icon from 'components/Tools/Icon';
import { Container } from './styles';

interface inputErrorProps {
  inputName: string;
  message: string;
}

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  icon?: string;
  iconError?: string;
  iconSuccess?: string;
  width?: number | string;
  handleInputError?(data: inputErrorProps): void;
  messageErrorOnBlur?: string;
  isDisabled?: boolean;
  inputValue?: string;
  dateMin?: string;
}

const DateInput: React.FC<InputProps> = ({
  name,
  handleInputError,
  messageErrorOnBlur,
  isDisabled,
  dateMin,
  ...rest
}) => {
  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name);

  const [success, setSuccess] = useState(false);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      setValue: (ref, value) => {
        setSuccess(false);
        ref.value = value;
        clearError();
      },
    });
  }, [fieldName, registerField, clearError]);

  const handleBlur = useCallback(
    event => {
      if (!event.target.value) {
        if (!!handleInputError && !!messageErrorOnBlur) {
          handleInputError({
            inputName: name,
            message: messageErrorOnBlur,
          });
        }
      } else return;
    },
    [handleInputError, messageErrorOnBlur, name]
  );

  return (
    <Container error={!!error} success={success}>
      <div className="input-wrapper">
        {/* @ts-ignore */}
        <input
          name={name}
          id={name}
          type="date"
          ref={inputRef}
          defaultValue={defaultValue}
          onBlur={handleBlur}
          disabled={isDisabled}
          minLength={1}
          min={dateMin}
          onFocus={() => {
            clearError();
          }}
          {...rest}
        />
        <label htmlFor={name} className="icon">
          <Icon icon={inputDateIcon} color="#0095E8" />
        </label>
      </div>
    </Container>
  );
};

export default DateInput;
